import React from 'react';
import { EmployeeActivityApportionmentFragment } from '@rd-web-markets/shared/dist/financialSection/employeeActivity';
const ApportionmentsList = _ref => {
  let {
    claim,
    sortedClaimProjectReports,
    handleApportionmentChange,
    claimEmployeeRndApportionmentsService,
    model,
    apportionmentable_type,
    claimEmployeeRndApportRef,
    isShowInvolvement
  } = _ref;
  const findApportionmentForModelAndProject = (model, claim_project_report) => {
    var _model$claim_employee;
    return model === null || model === void 0 || (_model$claim_employee = model.claim_employee_rnd_apportionments) === null || _model$claim_employee === void 0 ? void 0 : _model$claim_employee.find(a => {
      return a.apportionmentable_id === model.id && a.apportionmentable_type === apportionmentable_type && a.claim_project_report_id === claim_project_report.id;
    });
  };
  const modelApportionmentsForProjects = sortedClaimProjectReports.map((claim_project_report, reportIndex) => {
    const existingApportionmentForModelAndProject = findApportionmentForModelAndProject(model, claim_project_report);
    const apportionment = existingApportionmentForModelAndProject || {
      apportionmentable_id: model.id,
      apportionmentable_type: apportionmentable_type,
      claim_project_report_id: claim_project_report.id
    };
    return apportionment;
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: claimEmployeeRndApportRef,
    className: "d-flex cost_categories_subpage_row_cell"
  }, modelApportionmentsForProjects.map((apportionment, index) => /*#__PURE__*/React.createElement(EmployeeActivityApportionmentFragment, {
    key: index,
    claim: claim,
    type: apportionmentable_type,
    apportionment: apportionment,
    handleApportionmentChange: apportionment => handleApportionmentChange(model, apportionment),
    claimEmployeeRndApportionmentsService: claimEmployeeRndApportionmentsService,
    isShowInvolvement: isShowInvolvement
  })));
};
export default ApportionmentsList;